import { Component, inject, OnInit } from '@angular/core';
import { first, get } from 'lodash';
import { Subject, filter, take, takeUntil } from 'rxjs';
import { ReferenceService } from './services/reference.service';
import { UserService } from './services/user.service';
import { AbstractComponent } from './shared/components/abstract-component';
import { User } from './shared/models/user';
import { AuthStore } from './stores/auth.store';
import { ReferenceStore } from './stores/reference.store';
import { LoginResponse, OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from './services/auth.service';
import '@angular/localize/init';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent extends AbstractComponent implements OnInit {
  title = 'SEDMS-KendoUI';
  userLoaded: Subject<boolean> = new Subject<boolean>();
  user: any;
  authResult: any;
  public isDialogVisible: boolean = false;
  showDetails = false;
  location = window.location.href;
  referrer = document.referrer;
  userAgent = navigator.userAgent;
  screenResolution = `${screen.width}x${screen.height}`;

  constructor(
    private authService: AuthService
  ) {
    super();
  }

  ngOnInit() {
    this.authService.completeAuthentication();
  }

  public openDialog(): void {
    this.isDialogVisible = true;
  }

  public closeDialog(): void {
    this.isDialogVisible = false;
    this.showDetails = false;
  }

  toggleDetails(event: Event) {
    event.preventDefault();
    this.showDetails = !this.showDetails;
  }

  afterOnDestroy(): void {
    // afterOnDestroy
  }
}
